import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { IsEmail, IsOptional, MaxLength } from 'class-validator';

import { INVALID_EMAIL, TOO_LONG_STRING } from '../constants';
import { BaseDecoratorOptions } from '../types';

export function ApiPropertyEmail({ isOptional, ...options }: BaseDecoratorOptions<string> = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = { type: String, example: 'koko@ko.ko', description: 'Email', ...options };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsEmail({}, { message: INVALID_EMAIL }),
    MaxLength(256, { message: TOO_LONG_STRING }),
  );
}
